import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadAccesses () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.pagination.getParams(),
    })

    api.get('accesses', { params })
      .then(result => {
        this.accesses = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  loadTotals (type) {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.pagination.getParams(),
      profileType: type,
    })

    api.get('accesses', { params })
      .then(result => {
        this.totals[type] = result.data['hydra:totalItems']
      })
      .catch(error => {
        this.error = error
      })
  },

  exportAccesses: function () {
    const api = getApiClient(this.$store)

    api.get('accesses/export', {
      responseType: 'blob',
    })
      .then(result => {
        const url = window.URL.createObjectURL(new Blob([result.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'export.csv')
        document.body.appendChild(link)
        link.click()
      })
      .catch(error => {
        console.log(error)
      })
  },
}
